import { ReactNode } from 'react';
import { ITableColumn } from './types';

export const resolveColumnTitle = <T>(
  title: ITableColumn<T>['title']
): ReactNode => {
  if (typeof title === 'function') {
    return title({ sortColumns: [], sortOrder: undefined, filters: {} });
  }
  return title;
};
